import {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
} from '../wallet/walletDateRange'

export type DashboardDatePreset =
  | 'today'
  | 'yesterday'
  | 'last7'
  | 'thisMonth'
  | 'thisYear'
  | 'lastYear'
  | 'month'

export type DashboardFilterState = {
  preset: DashboardDatePreset
  date_from: string
  date_to: string
  month?: string
  label: string
}

export const DASHBOARD_QUICK_PRESETS: {
  id: Exclude<DashboardDatePreset, 'month'>
  label: string
}[] = [
  {id: 'today', label: 'Today'},
  {id: 'yesterday', label: 'Yesterday'},
  {id: 'last7', label: 'Last 7 days'},
  {id: 'thisMonth', label: 'This month'},
  {id: 'thisYear', label: 'This year'},
  {id: 'lastYear', label: 'Last year'},
]

const monthLabel = (monthValue: string) => {
  const [year, month] = monthValue.split('-').map(Number)
  if (!year || !month) return monthValue
  return new Date(year, month - 1, 1).toLocaleDateString(undefined, {
    month: 'long',
    year: 'numeric',
  })
}

const rangeForMonth = (monthValue: string): Omit<DashboardFilterState, 'preset'> => {
  const [year, month] = monthValue.split('-').map(Number)
  const from = new Date(year, month - 1, 1)
  const to = new Date(year, month, 0)
  return {
    date_from: toDateInputValue(from),
    date_to: toDateInputValue(to),
    month: monthValue,
    label: monthLabel(monthValue),
  }
}

export const getDefaultDashboardFilter = (): DashboardFilterState => {
  const range = getRangeForPreset('thisMonth')
  return {...range, preset: 'thisMonth'}
}

export const buildDashboardFilterState = (
  preset: DashboardDatePreset,
  monthValue?: string
): DashboardFilterState => {
  if (preset === 'month') {
    const month = monthValue || toDateInputValue(new Date()).slice(0, 7)
    return {...rangeForMonth(month), preset: 'month'}
  }
  const range = getRangeForPreset(preset)
  return {...range, preset}
}

/** API query body for GET /admin/getAllData */
export const toDashboardApiFilter = (filter: DashboardFilterState) => {
  if (filter.preset === 'month' && filter.month) {
    return {
      month: filter.month,
      date_from: filter.date_from,
      date_to: filter.date_to,
    }
  }
  return {
    date_from: filter.date_from,
    date_to: filter.date_to,
  }
}

export const formatDashboardRangeSummary = (filter: DashboardFilterState): string => {
  if (filter.date_from === filter.date_to) {
    return formatDisplayDate(filter.date_from)
  }
  return `${formatDisplayDate(filter.date_from)} – ${formatDisplayDate(filter.date_to)}`
}
